import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    ContentChild,
    EventEmitter,
    input,
    Output,
    TemplateRef,
} from '@angular/core';
import { ColourPaletteType } from '@dxp/core/models';
import { ChannelType } from '@dxp/core/types';

@Component({
    selector: 'telxl-panel',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    templateUrl: './panel.component.html',
    styleUrls: [
        './panel.component.scss',
        './panel.component.default.scss',
        './panel.component.webchat.scss',
        './panel.component.email.scss',
        './panel.component.whatsapp.scss',
        './panel.component.instagram.scss',
        './panel.component.voice.scss',
        './panel.component.twitter.scss',
        './panel.component.facebook.scss',
    ],
    host: {
        '[class]': 'class || ""',
        '(mouseenter)': 'onMouseEnter()',
        '(mouseleave)': 'onMouseLeave()',
    },
})
export class TelXLPanelComponent {
    theme = input<ColourPaletteType | ChannelType | 'default'>('default');
    minHeight = input<string>();
    maxHeight = input<string>();
    height = input<string>();
    isExpanded = input<boolean>(true);
    highlight = input<boolean>(false);
    selected = input<boolean>(false);
    hover = input<boolean>(false);
    overflow = input<'auto' | 'hidden' | 'none'>('none');
    border = input<boolean>(true);
    cardClass = input<string>('');
    headerClass = input<string>('');
    bodyClass = input<string>('');
    footerClass = input<string>('');

    @Output() hoverState = new EventEmitter<boolean>();

    @ContentChild('cardHeader', { static: true })
    headerTemplate!: TemplateRef<unknown>;
    @ContentChild('cardBody', { static: true })
    bodyTemplate!: TemplateRef<unknown>;
    @ContentChild('cardFooter', { static: true })
    footerTemplate!: TemplateRef<unknown>;

    onMouseEnter() {
        this.hoverState.emit(true);
    }

    onMouseLeave() {
        this.hoverState.emit(false);
    }

    readonly cardClasses = computed<string[]>(() => {
        const classes: string[] = [this.theme().toLowerCase()];

        if (this.cardClass().length > 0) classes.push(this.cardClass());
        if (this.hover()) classes.push('hover');
        if (this.highlight()) classes.push('shadow');
        if (this.selected()) classes.push('selected');
        if (this.overflow() === 'auto') classes.push('auto');
        if (this.overflow() === 'hidden') classes.push('hidden');
        if (!this.border()) classes.push('no-border');

        return classes;
    });
}
